import { Component, ViewChildren, ElementRef, ViewChild, QueryList } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatDialog } from '@angular/material/dialog';
import { SideNavigationService } from '../side-navigation/side-navigation.service';
import { aspMngr } from '../asp/AspMngr';
import { MapMngr } from '../asp/MapMngr';
import * as consts from '../common/consts';
import { AppInjector, IMenu } from '../common/inject';
import { AspObject } from '../asp/AspObject';
import { ObjectsMenuService } from '../menu-bars/objects-menu.service';
import { AroService } from '../aro/aro.service';
import { IMapClickHandler, IMapMngr } from '../asp/interfaces';
import * as aspSettings from '../asp/aspSettings';
//import { TrackCreatorComponent } from '../aro/track-creator/track-creator.component';
import { Animations } from '@core_n/Animations';
import { AroSensorService } from 'src/app/aro/aro-sensor.service';

//
// Objects Menu
//
@Component({
  selector: 'objects-menu',
  templateUrl: './objects-menu.component.html',
  styleUrls: ['./objects-menu.component.scss'],
  animations: [
    Animations.WindowOpenCloseFade
  ]
})

export class ObjectsMenuComponent implements IMenu {
  private static readonly DBL_CLICK_MAX_DELAY = 0; // TBD: 200;

  public isvisbut = false;
  public isviscon = false;
  public isvisobj = false;

  objectsMenuLeft: number = 0;
  objectsMenuTop: number = 0;

  contextMenuLeft: number = 0;
  contextMenuTop: number = 0;

  buttMenuLeft: number = 0;
  buttMenuTop: number = 0;

  contextMenuTitles = [];
  globalMenuTitles = [];

  public objects: AspObject[] = null;
  private actions: number[] = null;
  private globalActions: number[] = null;
  private contextObject: AspObject = null;
  private internalObjectsMenu = false;
  private mapMngr: IMapMngr = undefined;
  private mapClickHandler: IMapClickHandler = undefined;
  private clickTimer = null;
  private preventClick = false;

  @ViewChildren(MatMenuTrigger) menuTriggers: QueryList<MatMenuTrigger>;
  @ViewChild('trackCreator', { read: ElementRef }) trackCreator: ElementRef;

  constructor(private menuService: ObjectsMenuService,
    private sidenavService: SideNavigationService,
    private aroService: AroService,
    private dialog: MatDialog) {
    menuService.setMenu(this);
  }

  private setMenuPosition(event, mapMngr: IMapMngr, contextMenu: boolean) {
    let menuLeft: number;
    let menuTop: number;
    if (event instanceof MouseEvent) {
      menuLeft = event.clientX;
      menuTop = event.clientY;
    }
    else {
      let mapDivElem: Element = mapMngr.getMap().div;
      let mapDivRect = mapDivElem.getBoundingClientRect();
      menuLeft = event.screenPoint.x + mapDivRect.left;
      menuTop = event.screenPoint.y + mapDivRect.top;
    }
    if (contextMenu) {
      this.contextMenuLeft = menuLeft;
      this.contextMenuTop = menuTop;
      if (!this.isvisobj) {
        this.buttMenuLeft = menuLeft;
        this.buttMenuTop = menuTop;
      }
      else {
        this.contextMenuLeft = this.objectsMenuLeft + event.currentTarget.offsetWidth + 3;
        this.contextMenuTop = this.objectsMenuTop + event.currentTarget.offsetTop;
      }
    }
    else {
      this.objectsMenuLeft = menuLeft;
      this.objectsMenuTop = menuTop;
      this.buttMenuLeft = menuLeft;
      this.buttMenuTop = menuTop;
    }
  }

  // Show objects menu. 
  // If internal, both left and right clicks open the context menu,
  // else left click hooks the object, right click opens context menu.
  public showObjectsMenu(objects: AspObject[], event, mapMngr: IMapMngr, mapClickHandler?: IMapClickHandler, internal?: boolean): boolean {
    this.isvisobj = true;
    this.internalObjectsMenu = internal === true;
    this.mapMngr = mapMngr;
    this.mapClickHandler = mapClickHandler;
    this.objects = objects.sort((a, b) => a.id.toString() > b.id.toString() ? 1 : -1);
    this.setMenuPosition(event, mapMngr, false);
    return true;
  }

  // Show context menu.
  // If one object, open context menu, else open internal objects menu.
  public showContextMenu(objects: AspObject[], event, mapMngr: IMapMngr): boolean {
    if (!this.isvisobj)
      aspSettings.save2Secondary();
    this.mapMngr = mapMngr;
    this.setMenuPosition(event, mapMngr, true);
    if (objects) {
      this.isviscon = true;
      let relevantObjects = [];
      for (let obj of objects) {
        if (this.buildContextMenuTitles(obj))
          relevantObjects.push(obj);
      }
      if (relevantObjects.length == 1) {
        this.contextObject = relevantObjects[0];
        if (!this.buildContextMenuTitles(this.contextObject))
          return false;
        this.isvisbut = false;
      }
      else if (relevantObjects.length > 1) {
        this.isviscon = false;
        this.isvisbut = false;
        this.showObjectsMenu(relevantObjects, event, mapMngr, null, true /* internal */);
      }
      return true;
    }
    else {
      // if we right clicked on nothing...
      this.contextObject = null;
      this.buildOnMapMenuTitles();
      this.isvisbut = true;
    }
  }

  public handleKeyboardEvent(event: KeyboardEvent): boolean {
    // Handle <Esc> key if any of the menus or open
    if (event.key == 'Escape') {
      this.hideMenus(true);
      return true;
    }
    return false;
  }

  public objectMenuOpened: boolean = false;
  // Objects menu left click
  // Delay handling of the click, waiting for a possible double click.
  onObjectsMenuClick(menuTitle, event) {
    this.isviscon = true;
    let newSelectedIds = new Set();
    newSelectedIds.add(menuTitle.id);
    aspSettings.setSelectedIds(newSelectedIds);
    this.objectMenuOpened = true;
    if (this.internalObjectsMenu) {
      this.handleObjectsMenuClick(menuTitle, event);
    }
    else {
      this.clickTimer = setTimeout(() => {
        if (!this.preventClick)
          this.handleObjectsMenuClick(menuTitle, event);
        this.preventClick = false;
      }, ObjectsMenuComponent.DBL_CLICK_MAX_DELAY);
    }
  }

  onMouseLeaveBox() {
    // this.isviscon = false;
    this.objectMenuOpened = false;
    aspSettings.clearSelectedIds();
  }

  // Objects menu double click
  // Perform double click action of opening the object's ARO
  onObjectsMenuDblClick(obj, event) {
    if (!this.internalObjectsMenu)
      return;

    clearTimeout(this.clickTimer);
    this.preventClick = true;

    // let obj = this.getObjectByMenuTitle(menuTitle.title);
    if (obj != null)
      obj.objectsPool.handleUserAction(consts.USER_ACTION_ARO, obj, this.mapMngr);
    this.hideMenus(true);
  }

  // Objects menu right click, open context menu
  onObjectsContextMenu(obj, event) {
    // let obj = this.getObjectByMenuTitle(menuTitle);
    if (obj != null) {
      // !!! move the object menu a lil bit to the right...
      this.showContextMenu([obj], event, this.mapMngr);
    }
  }

  // Context menu left click
  onContextMenuClick(menuTitle, event) {
    let action = this.getActionByMenuTitle(menuTitle);
    if (!this.contextObject) {
      this.hideMenus();
      this.handleLocalUserAction(action, event);
      return;
    }

    if (this.contextObject.active()) {
      // Perform clicked action
      this.contextObject.objectsPool.handleUserAction(action, this.contextObject, this.mapMngr, this.dialog);
      this.hideMenus(true);
    }
  }

  handleLocalUserAction(action: number, event): boolean {
    return false;
  }

  createTrackClick() {
  //  this.dialog.open(TrackCreatorComponent, TrackCreatorComponent.createDialogConfig(100, 200));
    AppInjector.get(AroSensorService).showWindowNewSensor();
    this.hideMenus();
  }

  centerClick() {
    this.mapMngr.setMapCenter(aspSettings.savedRClickP);
    this.hideMenus();
  }

  // Build objects menu titles
  // private buildObjectsMenuTitles(): boolean {
  //   this.objectsMenuTitles = [];
  //   if (this.objects && this.objects.length > 0) {
  //     for (let obj of this.objects)
  //       this.objectsMenuTitles.push(new objectData(obj));
  //     this.objectsMenuTitles = this.objectsMenuTitles.sort();
  //     return true;
  //   }
  //   return false;
  // }

  // Build context menu titles
  private buildContextMenuTitles(obj: AspObject): boolean {
    this.contextMenuTitles = [];
    this.globalMenuTitles = [];
    this.actions = obj.objectsPool.contextMenuActions(obj);
    this.globalActions = obj.objectsPool.globalMenuActions(obj);
    if (this.actions.length > 0 || this.globalActions.length > 0) {
      for (let action of this.actions) {
        this.contextMenuTitles.push(consts.constsMngr.userActionTitle(action));
      }
      for (let action of this.globalActions) {
        this.globalMenuTitles.push(consts.constsMngr.userActionTitle(action));
      }
      return true;
    }
    return false;
  }

  private buildOnMapMenuTitles(): boolean {
    this.contextMenuTitles = [];
    this.globalMenuTitles = [];
    // this.globalActions = [consts.USER_ACTION_CREATE_TRACK, consts.USER_ACTION_PIN_POINT, consts.USER_ACTION_CENTER];
    // this.globalActions = [consts.USER_ACTION_CREATE_TRACK, consts.USER_ACTION_CENTER];
    this.globalActions = [];
    if (this.globalActions.length > 0) {
      for (let action of this.globalActions) {
        this.globalMenuTitles.push(consts.constsMngr.userActionTitle(action));
      }
      return true;
    }
    return false;
  }

  // Find object by menu title
  // private getObjectByMenuTitle(menuTitle): AspObject {
  //   let index = this.objectsMenuTitles.indexOf(menuTitle);
  //   for (let obj of this.objects) {
  //     if (obj.getTitle() == menuTitle) {
  //       return obj;
  //     }
  //   }

  //   return null;
  // }

  // Find action by menu title
  private getActionByMenuTitle(menuTitle): number {
    let index = this.contextMenuTitles.indexOf(menuTitle);
    if (index >= 0)
      return this.actions[index];
    else {
      index = this.globalMenuTitles.indexOf(menuTitle);
      return this.globalActions[index];
    }
  }

  // Handle objects menu click.
  // If internal activation, open context menu, else hook object.
  private handleObjectsMenuClick(obj, event) {
    // let obj = this.getObjectByMenuTitle(menuTitle.title);
    if (this.internalObjectsMenu) {
      if (obj != null) {
        event.stopPropagation();
        this.showContextMenu([obj], event, this.mapMngr)
      }
    }
    else {
      if (obj != null) {
        if (this.mapClickHandler) {
          this.mapClickHandler.onObjectsClicked([obj]);
        }
        else {
          if (aspMngr.hookObject(obj))
            MapMngr.redrawAllMaps();
        }
      }
    }
  }

  hideMenus(force?: boolean) {
    if (!this.objectMenuOpened || force) {
      this.isvisobj = false;
      this.isviscon = false;
      this.isvisbut = false;
    }
    return;
  }
}
